import { FunctionComponent } from "react";
import OptionBox, { OptionBoxProps } from "./OptionBox";
import ListItem from "../ListItem/ListItem";
import Column from "../Column/Column";
import Button from "../Button/Button";

export interface OptionBoxesData {
  id: string;
  title: string;
  heading: string;
  description: string;
  encrypt?: boolean;
  addToScore?: boolean;
  type: string;
  validations: {
    required?: boolean;
  };
  components: Array<OptionBoxProps>;
  properties: {
    choices: Array<OptionBoxProps>;
  };
}

type OptionBoxesProps = {
  data: OptionBoxesData;
  onDataSelected: Function;
  onBack?: Function;
  errors: { [key: string]: String };
  nextPage?: string;
  isLoading?: boolean;
};

const OptionBoxes: FunctionComponent<OptionBoxesProps> = ({
  data,
  onDataSelected,
  onBack,
  nextPage,
  isLoading,
}) => {
  const content: JSX.Element[] = [];
  const isMultipleThree = data.components.length
    ? data.components.length % 3 === 0
    : false;
  const isMultipleFour = data.components.length
    ? data.components.length % 4 === 0
    : false;
  data.components.forEach((el) => {
    const width =
      data.components.length === 1
        ? "lg:w-full"
        : isMultipleThree
        ? "lg:w-1/3"
        : "lg:w-1/2";
    const padding = isMultipleThree ? "lg:px-3" : "lg:px-6";
    return (content[el.index] = (
      <div
        className={`px-2 py-2 w-full lg:py-2 ${padding} ${width}`}
        key={el.id}
      >
        <OptionBox
          {...el}
          onSelect={onDataSelected}
          questionId={data.id}
          isLoading={isLoading}
          fullWidth={isMultipleFour}
        >
          {el.list.map((listItem, index) => (
            <ListItem
              icon={listItem.icon}
              key={listItem.id}
              last={index === el.list.length - 1}
            >
              {listItem.label}
            </ListItem>
          ))}
        </OptionBox>
      </div>
    ));
  });
  return (
    <div>
      <div className="flex flex-wrap items-stretch mb-12 lg:-mx-8">
        {content}
      </div>
      {onBack ? (
        <div className="flex flex-wrap justify-center">
          <Button variant="text" onPress={() => onBack()}>
            Zurück
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default OptionBoxes;
